module.exports = __webpack_public_path__ + "media/components/Avatar/avatar-6c4783600a34de4a5f5c8989bd235139.png";